import { render } from "./IconArrowDonw.vue?vue&type=template&id=6587ae79"
import script from "./IconArrowDonw.vue?vue&type=script&lang=js"
export * from "./IconArrowDonw.vue?vue&type=script&lang=js"
script.render = render

export default script